import types from "../actionTypes";

export default (
  state = {
    maxSteps: 0,
    minSteps: 0,
    step: 1,
    isAdded: false,
    airFormPdfLink: undefined,
    airEmployeeStatememt: undefined
  },
  action
) => {
  switch (action.type) {
    case types.SET_AIR_CURRENT_STEP:
      return Object.assign({}, state, { step: action.step });
    case types.SET_AIR_MAX_STEPS:
      return Object.assign({}, state, { maxSteps: action.maxSteps });
    case types.SET_AIR_MIN_STEPS:
      return Object.assign({}, state, { minSteps: action.minSteps });
    case types.SET_AIR_IS_ADDED:
      return Object.assign({}, state, { isAdded: action.isAdded });
    case types.SET_AIR_FORM_PDF:
      return Object.assign({}, state, {
        airFormPdfLink: action.airFormPdfLink,
      });
    case types.SET_AIR_EMPLOYEE_STATEMENT:
      return Object.assign({}, state, { airEmployeeStatememt: action.airEmployeeStatememt });
    default:
      return state;
  }
};
